import React, { useEffect } from "react";
import "./Message.css";

interface Props {
  setAlert: (alert: boolean) => void;
}

const Message = ({ setAlert }: Props) => {
  useEffect(() => {
    console.log("Ever here?");
    setTimeout(() => {
      setAlert(false);
    }, 3000);
  }, []);

  return <p className="fade-in-and-out">copied to clipboard</p>;
};

export default Message;
